import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { LanguagesActions } from './store/languages/languages.actions';
import { WebsocketService } from './services/websocket.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'SVET-front';
  private readonly webSocketService: WebsocketService =
    inject(WebsocketService);
  private readonly store: Store = inject(Store);
  private subscrition?: Subscription;

  ngOnInit(): void {
    this.store.dispatch(LanguagesActions.loadLanguages());
  }

  ngOnDestroy(): void {
    this.subscrition?.unsubscribe();
  }
}
